module.exports = __webpack_public_path__ + "static/media/night-shot.13a3f126.webp";